export const defaultFilters = {
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    dateFrom: '',
    dateTo: '',
    approvedStatusDateFrom: '',
    approvedStatusDateTo: '',
    shippedStatusDateFrom: '',
    shippedStatusDateTo: '',
    deliveryStatusDateFrom: '',
    deliveryStatusDateTo: '',
    ids: '',
    cpaId: '',
    prepayment: null,
    search: '',
    synchronizeIncorrectly: null,
    hoursFromApprove: null,
    hasTracker: null,
    isSynced: null,
    tracker: null,
    historyDateFrom: '',
    historyDateTo: '',
    favorite: null,
    countries: [],
    regions: [],
    districts: [],
    cities: [],
    warehouses: [],
    deliveryServices: [],
    offers: [],
    salesTypes: [],
    products: [],
    attributes: [],
    status: [],
    orderSubstatus: [],
    historyStatus: [],
    historySubstatus: [],
  },
  order: { id: 'DESC' },
  clientOptions: {
    filterPanelExpanded: false,
    dateType: 'date',
    dateFrom: '',
    dateTo: '',
    selectedColumns: [],
  },
}
